<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import importPlanModal from './importPlanModalContent.vue'

export default {
  name: 'importPlanButtonAndModal',
  components: {
    importPlanModal
  },
  props: ['zone', 'routesubmit'],
  data() {
    return {
      showModalPlan: false
    }
  },
  methods: {
    afficheModalPlan() {
      this.showModalPlan = true;
    },
    closeModalPlan() {
      this.showModalPlan = false;
    }
  }
}
</script>

<template>
  <div>
    <button id="show-modal-plan" class="buttonOriginal" @click="afficheModalPlan" :title="trans.get('common.uploadplan')"><span class="glyphicon glyphicon-upload"></span></button>

      <!-- use the modal component, pass in the prop -->
      <importPlanModal v-if="showModalPlan" @close="closeModalPlan" :routesubmit="this.routesubmit"  :zone="this.zone"></importPlanModal>
  </div>
</template>